import { render, staticRenderFns } from "./register-case.vue?vue&type=template&id=0e322f08&scoped=true&"
import script from "./register-case.vue?vue&type=script&lang=ts&"
export * from "./register-case.vue?vue&type=script&lang=ts&"
import style0 from "./register-case.vue?vue&type=style&index=0&id=0e322f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e322f08",
  null
  
)

export default component.exports